import { Component, OnInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { DisputeService } from '@app/_services/dispute.service';
import { first } from 'rxjs/operators';
import { superVerifierDisputeList } from '@app/_models/superVerifierDisputeList';
import { Subject } from 'rxjs';
import { DocumentVerificationListService } from '@app/_services/document-verification-list.service';
import { environment } from '@environments/environment';
import { applicationData } from '@app/_models/applicationData';
import { disputeStatus } from '@app/_models/disputeStatus';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-verifier-dispute-list',
  templateUrl: './verifier-dispute-list.component.html',
  styleUrls: ['./verifier-dispute-list.component.css']
})
export class VerifierDisputeListComponent implements OnInit {
  upload_doc_path: any = '';
  originalDocUploadFilePath: any;
  showFlag: boolean = false;
  selectedImageIndex: number = -1;
  currentIndex
  reason: string;
  getId: number;
  dtTrigger: Subject<any> = new Subject<any>();
  ApplicationDate: string;
  VerifierName: string;
  StatusOpen: string;
  Remark: string;
  doc_name: string;
  college_name: string;
  year: string;
  disputeStatus: disputeStatus[];
  first_name: string;
  last_name: string;
  stream_name: string;
  branch_nm: string;
  semester: string;
  statuschangeid;
  status;
  isVrPdf: boolean = false;
  isVrImage: boolean = false;
  isUPdf: boolean = false;
  isUImage: boolean = false;
  fileURL;
  fileURL1;
  src;
  src1;
  dispute = { status: 0 };
  //Kartik added following:
  monthOfPassing;
  IsStatusSelected = false;
  documentStatus;
  updateddocumentStatus;
  radio = true;
  disputeNewStatus
  isImageR = false;
  isImageL = false;
  noImage1 = false;
  noImage2 = false;
  imgname = "uploadImg1"
  imgname2 = "uploadImg2"

  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  @ViewChild('radioInput') radioInputs: ElementRef;
  @ViewChild('radioInput1') radioInputs1: ElementRef;
  @ViewChild('radioInput2') radioInputs2: ElementRef;
  @ViewChild('showModalBoxImage', { read: TemplateRef }) showModalBoxImage: TemplateRef<any>;

  showLightbox(index) {
    this.selectedImageIndex = index;
    this.showFlag = true;

    this.imageObject = [
      {
        image: this.upload_doc_path,
        alt: 'alt of image', // Optional
        title: 'To be verified' // Optional: Show image with description text 
      },
      {
        image: this.originalDocUploadFilePath, // Support base64 image
        title: 'System document', //Optional: You can use this key if want to show image with title
        alt: 'Image alt' //Optional: You can use this key if want to show image with alt
      }
    ];
  }
  closeEventHandler() {
    this.showFlag = false;
    this.currentIndex = -1;
  }

  imageObject: Array<object> = [
    {
      image: '../../assets/images/img.JPG',
      alt: 'alt of image', // Optional
      title: 'To be verified' // Optional: Show image with description text 
    },
    {
      image: '../../assets/images/img.JPG', // Support base64 image
      title: 'System document', //Optional: You can use this key if want to show image with title
      alt: 'Image alt' //Optional: You can use this key if want to show image with alt
    }
  ];
  // public data = [
  //   {applicationId: 'AP234', contactPerson: 'Ramesh Singh', document: 'Marksheet', status: 'Open'},
  //   {applicationId: 'AP897', contactPerson: 'Vikas Patel', document: 'Degree', status: 'Solved'},
  //   {applicationId: 'AP556', contactPerson: 'Ratan Singh', document: 'Degree', status: 'Not a Dispute'},
  // ];

  title = 'docVerificationList';
  dtOptions: DataTables.Settings = {};
  request: superVerifierDisputeList[];
  applicationData: applicationData[];

  constructor(
    private disputeService: DisputeService,
    private documentVerificationListService: DocumentVerificationListService,
    config: NgbModalConfig,
    private modalService: NgbModal,
    private SpinnerService: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true
    };

    this.disputeService.getSuperverifierDisputeList()
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.request = data.respData;

          console.log(this.request)
          this.dtTrigger.next();
        },
        error => {
          console.log(error)
        })

  }

  showReason(strReason) {
    this.reason = strReason;
  }

  getDataForStatusChange(id, status, data) {
    this.statuschangeid = id;
    this.status = status;
    this.documentStatus = data.vrStatus
    console.log(this.statuschangeid, this.status);
    this.radioInputs.nativeElement.checked = false;
    this.radioInputs1.nativeElement.checked = false;
    this.radioInputs2.nativeElement.checked = false;
  }

  _base64ToArrayBuffer(base64) {
    var binary_string = base64.replace(/\\n/g, '');
    binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  openPdf() {
    window.open(this.fileURL);
  }

  openModal(id) {
    this.getId = id;
    this.isImageR = false;
    this.isImageL = false;
    this.isVrImage = false;
    this.isVrPdf = false;
    this.upload_doc_path = '';
    this.originalDocUploadFilePath = '';
    this.documentVerificationListService.getverifydocument(id)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.documentVerificationListService.getverifydocumentImage(`${environment.apiUrl}` + data.respData[0].upload_doc_path).pipe(first())
            .subscribe(
              add => {
                console.log("addadd---", add)
                let reader = new FileReader();
                console.log("reader---", reader)
                if (add.type == "application/pdf") {
                  this.isVrPdf = true;
                  this.isVrImage = false;
                  reader.addEventListener("load", () => {
                    this.upload_doc_path = reader.result;
                    var base64Array = this.upload_doc_path.substring(28);
                    console.log("=====base64Array===========", base64Array);
                    this.src = this._base64ToArrayBuffer(base64Array);
                    let file = new Blob([add], { type: 'application/pdf' });
                    this.fileURL = URL.createObjectURL(file);
                    // window.open(this.fileURL);                    
                  }, false);
                  // this.src = this._base64ToArrayBuffer();
                } else {
                  this.isVrImage = true;
                  this.isVrPdf = false;
                  reader.addEventListener("load", () => {
                    this.upload_doc_path = reader.result;
                    this.noImage1 = false;
                    //this.upload_doc_pathString = this.upload_doc_path;
                    //alert(  this.upload_doc_path)
                  }, false);
                }
                if (add) {
                  reader.readAsDataURL(add);
                }
                this.isImageL = true;
                if (this.isVrPdf == true) {

                  var al = window.open('', 'OPEN');
                  window.setTimeout(function () { al.close() }, 100);
                }
                console.log("=======img===========L======", this.isImageR, this.isImageL);
                if (this.isImageL == true && this.isImageR == true) {
                  this.SpinnerService.hide();
                  this.modalService.open(this.showModalBoxImage, {windowClass: 'my-class',centered: true });
                }
                // this.upload_doc_path = add;
                //this.upload_doc_path = data.respData[0].upload_doc_path;
              }, error => {
                this.isVrImage = true;
                this.isVrPdf = false;
                this.SpinnerService.hide();
                this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', centered: true });
                this.upload_doc_path = "/University/assets/images/No-results-found.jpg"; // test server
                this.noImage1 = true;
                console.log(error)
              }
            )
            if(data.respData[0].originalDocUploadFilePath!=undefined){
              this.documentVerificationListService.getverifydocumentImage(`${environment.apiUrl}` + data.respData[0].originalDocUploadFilePath).pipe(first())
              .subscribe(
                data2 => {
                  console.log("data2---", data2, data2.type)
                  let reader = new FileReader();
                  if (data2.type == "application/pdf") {
                    this.isUPdf = true;
                    this.isUImage = false;
                    reader.addEventListener("load", () => {
                      this.originalDocUploadFilePath = reader.result;
                      var base64Array = this.originalDocUploadFilePath.substring(28);
                      console.log("=====base64Array===========", base64Array);
                      this.src1 = this._base64ToArrayBuffer(base64Array);
                      let file = new Blob([data2], { type: 'application/pdf' });
                      this.fileURL1 = URL.createObjectURL(file);
                    }, false);
                  } else {
                    this.isUImage = true;
                    this.isUPdf = false;
                    reader.addEventListener("load", () => {
                      this.originalDocUploadFilePath = reader.result;
                      console.log(reader.result);
                      this.noImage2 = false;
                    }, false);
                  }
                  console.log(this.isUImage, this.isUPdf, this.isVrImage, this.isVrPdf)
                  if (data2) {
                    // this.SpinnerService.hide();                  
                    // this.modalService.open(this.showModalBoxImage, { size: 'xl' ,centered: true});
                    reader.readAsDataURL(data2);
                  }
                  this.isImageR = true;
                  if (this.isUPdf == true) {
                    var al = window.open('', 'OPEN');
                    window.setTimeout(function () { al.close() }, 100);
                  }
                  console.log("=======img===========R======", this.isImageR, this.isImageL);
                  if (this.isImageL == true && this.isImageR == true) {
                    this.SpinnerService.hide();
                    this.modalService.open(this.showModalBoxImage, {windowClass: 'my-class', centered: true });
                  }
                }),
              console.log(this.request)
            this.imageObject = [];
            }
            else
            { 
              this.isUPdf = false;
              this.isUImage = true;
              this.isImageR = true;
              this.originalDocUploadFilePath = "/University/assets/images/No-results-found.jpg"; 
              this.noImage2 = true;
            }
            if (this.isImageL == true && this.isImageR == true) {
              this.SpinnerService.hide();
              this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', centered: true });            
            }          
          //this.dtTrigger.next();
        },
        error => {
          this.isUPdf = false;
          this.isUImage = true;
          this.isImageR = true;
          if (this.isImageL == true && this.isImageR == true) {
            this.SpinnerService.hide();
            this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class',centered: true });
          }
          this.upload_doc_path = "/University/assets/images/No-results-found.jpg";
          this.originalDocUploadFilePath = "/University/assets/images/No-results-found.jpg";
          this.noImage2 = true;
          console.log(error)
        }
      )
    this.SpinnerService.show();
  }

  getAppData(id) {
    this.disputeService.getVerificationRequestDetails(id)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.applicationData = data.respData;
          this.ApplicationDate = data.respData.req_date;
          this.VerifierName = data.respData.verifier_name;
          this.StatusOpen = data.respData.doc_status;
          this.Remark = data.respData.remark;
          this.doc_name = data.respData.doc_name;
          this.college_name = data.respData.college_name;
          this.year = data.respData.year;
          this.first_name = data.respData.first_name;
          this.last_name = data.respData.last_name;
          this.stream_name = data.respData.stream_name;
          this.branch_nm = data.respData.branch_nm;
          this.semester = data.respData.semester;
          this.monthOfPassing = data.respData.monthOfPassing;
          console.log(this.request)
          // this.dtTrigger.next();
        },
        error => {
          console.log(error)
        })
  }

  changeStatus(e) {
    this.IsStatusSelected = true;
    var id = this.getId;
    // this.statusRemark.id = this.getId;
    this.updateddocumentStatus = e.target.value;
    //  alert(status)

  }

  updateDisputeStatus() {

    var disStatus = new disputeStatus();
    disStatus.id = this.statuschangeid;
    disStatus.status = this.status;
    disStatus.updatedstatus = this.updateddocumentStatus;
    console.log(this.statuschangeid)
    this.disputeService.updateDispute(disStatus)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.SpinnerService.hide();
          this.modalService.open(this.showModalBoxTemplate);
          //refresh Datatale
          this.disputeService.getSuperverifierDisputeList()
            .pipe(first())
            .subscribe(
              data => {
                console.log("response---", data)
                this.request = data.respData;
                console.log(this.request)
                //this.dtTrigger.next();
              },
              error => {
                console.log(error)
              })
        },
        error => {
          console.log(error)
        }
      ),
      this.SpinnerService.show();
  };
  refresh(): void {
    location.reload();
    // this.modalService.dismissAll(this.showModalBoxTemplate);

    // this.returnUrl = "university";
    // this.router.navigate([this.returnUrl]);
  }

}
